// Tiny, escape-first formatters for previews. Input is merchant-authored text
// after variable substitution; output is safe to bind with innerHTML.

const escapeHtml = (s: string) =>
  s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const safeHref = (url: string) => (/^(https?:|mailto:|tel:)/i.test(url) ? url : "#");

// Email body: **bold**, _italic_, [label](https://url), newlines.
export const formatEmailText = (text: string, linkColor: string) =>
  escapeHtml(text)
    .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (_, label, url) =>
      `<a href="${safeHref(url)}" style="color:${escapeHtml(linkColor)};text-decoration:underline">${label}</a>`,
    )
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|\W)_(.+?)_(?=\W|$)/g, "$1<em>$2</em>")
    .replace(/\n/g, "<br/>");

// WhatsApp formatting: *bold*, _italic_, ~strike~, ```mono```.
export const formatWhatsAppText = (text: string) =>
  escapeHtml(text)
    .replace(/```([\s\S]+?)```/g, '<code style="font-family:monospace">$1</code>')
    .replace(/(^|\W)\*(\S(?:.*?\S)?)\*(?=\W|$)/g, "$1<strong>$2</strong>")
    .replace(/(^|\W)_(\S(?:.*?\S)?)_(?=\W|$)/g, "$1<em>$2</em>")
    .replace(/(^|\W)~(\S(?:.*?\S)?)~(?=\W|$)/g, "$1<s>$2</s>")
    .replace(/\n/g, "<br/>");

// Replace characters that force SMS into UCS-2 with GSM-7 equivalents; drops
// emoji and anything else without a sensible substitute.
const GSM_SUBSTITUTES: Record<string, string> = {
  "‘": "'",
  "’": "'",
  "“": '"',
  "”": '"',
  "–": "-",
  "—": "-",
  "…": "...",
  " ": " ",
  "á": "a",
  "â": "a",
  "ê": "e",
  "ë": "e",
  "î": "i",
  "ï": "i",
  "ô": "o",
  "û": "u",
  "ç": "c",
};

export const toGsmSafe = (text: string, nonGsm: string[]) => {
  let out = text;
  for (const ch of nonGsm) {
    out = out.split(ch).join(GSM_SUBSTITUTES[ch] ?? "");
  }
  return out.replace(/ {2,}/g, " ");
};
